import { IReleaseNote } from "./commonInterfaces";

export const otpSentSuccessfully = "You will recieve OTP SMS shortly!";
export const errorMessage = "Something went wrong, please try again";
export const failedToDownloadMessage = `Sorry the file can't be downloaded`;
export const arabicErrorMessage = "حدث خطأ ما ، برجاء المحاولة مرة اخري!";
export const arabicSuccessTransferMessage = 'تم التحويل بنجاح'
export const dateFormat = "YYYY/MM/DD";
export const noFilterDataMessage = `You can't search on nothing`;
export const egyptianNumberMsg = 'Phone number must be egyptian';
export const getDeductionsMsg = 'Press on filter to get the deductions';
export const firstOption = [{}];
export const checkSumInvoicesError = `Generating a new invoice in the background. Try again in a few minutes`;
//validation strings
export const spacesNotAllowedMsg = 'Spaces not allowed';
export const onlySpacesNotAllowedMsg = 'Only spaces are not allowed';
export const variableCasesMsg = 'Only accept letters, camelCase, or sneck_case';
export const englishInputError = "Please input with English";
export const arabicInputError = "Please input with Arabic";
//Emails default values
export const englishEmailData = {
    companyName: "CEQUENS",
    companyLogo: "https://elasticbeanstalk-us-east-1-927288046810.s3.amazonaws.com/Logos/cequens.png",
    headerAfterName: "is delighted to offer new benefit in collaboration with NowPay",
    description: "Now you can get your salary at any time, you don't need to wait for the end of the month with the Nowpay app",
    installmentOption: 3,
    ifFreePeriod: false,
    freePeriod: 6,
    refLink: "https://getnowpay.com/?lang=en&ref=cequens",
    salaryAdvanceService: "You can now request your salary at any point during the month trough Nowpay's app. The amount will be deducted from your next salary, the requested amount will be deposited to your bank account directly within 1 to 2 business days and you can repay the amount in up to 3 months installments plan.",
    paymentService: "You can charge your mobile and pay your bill (electricity, gas, water, internet, and land line) with just one click through NowPay's payment.",
    internalTransferringService: "You can transfer amounts from your Nowpay's account to your colleagues inside the company and the amount will be directly deducted from your monthly salary up to 3 months installments plan.",
    shoppingService: "Now you can benefit from our hassle-free shopping service, pick your favorite products and we will deliver them to your doorstep.",
    payrollDescription: "The payroll department will directly deduct the requested amounts from your monthly salary",
    serviceFees: 2.5,
    howItWorks1: "Use this link to",
    howItWorks2: "Request your salary at any point during the month",
    howItWorks3: "Pick your suitable installment plan up to three months",
    howItWorks4: "We will transfer your requested amount directly",
    videoLink: "https://www.youtube.com/watch?v=936fFoyhNtg",
    questionsString: "If you have any questions, please reply to this email or contact us at",
    questionsContact: "support@nowpay.cash"
}

export const arabicEmailData = {
    companyName: "SAKNAFATA",
    companyLogo: "https://elasticbeanstalk-us-east-1-927288046810.s3.amazonaws.com/Logos/saknafta.jpg",
    headerAfterName: "خدمة مميزة لمُوظفي",
    description: "دلوقتي تقدر تقبض مرتبك في أي وقت مش محتاج تستني لأخر الشهر مع تطبيق ناوباي.",
    installmentOption: 5,
    ifFreePeriod: false,
    freePeriod: "5",
    refLink: "https://getnowpay.com/?ref=saknafata",
    salaryAdvanceService: "تسطيع الحصول علي مرتبك في اي وقت خلال الشهر، المبلغ المطلوب بيتحول على حسابك خلال 1-2 يوم عمل ، تسطيع أيضاً تقسيط المبلغ بكل سهولة علي شهر أو اثنان أو ثلالثة.",
    paymentService: "دفع فواتيرك من كهرباء، غاز، مياه، خط أرضي، انترنت وتشحن رصيد لهاتفك بكل سهولة من راتب الشهر القادم بدون الحاجة لبطاقة بنكية.",
    internalTransferringService: "تستطيع تحويل نقود لأي من زملائك في الشركة من خلال التطبيق و يتم خصم النقود منك و سدادها على شهر أو اثنان أو ثلالثة.",
    shoppingService: "تستطيع شراء وتقسيط المشتريات ويتم خصم ثمنها تلقائيا من مرتبك دون أي متاعب أو إجراءات مرهقة, وسيصلك المنتج حتي باب البيت",
    payrollDescription: "يتم خصم الأقساط تلقائيًا من مرتبك التالي من خلال إدارة المرتبات بشركتك",
    serviceFees: 2.5,
    howItWorks1: "قــم بــتحـميل تطـبيـق نـاوبـاي من ",
    howItWorks2: "اطلب راتبك في أي وقت خلال الشهر",
    howItWorks3: "حدد أشهر السداد سواءا شهر أو اثنان أو ثلاثة",
    howItWorks4: "تحويل فوري لراتبك من خلال التطبيق",
    videoLink: "https://www.youtube.com/watch?v=936fFoyhNtg",
    questionsString: "الاستفسارات حول كيفية عمل الخدمة، يمكنك الرد علي الايميل أو التواصل معنا علي",
    questionsContact: "support@nowpay.cash"
}

export enum achFilesNames {
    HSBC = 'Processing HSBC Bank Requests list',
}

export enum collectionsSplitTypes {
    isBasedSplit = 1,
    isManualSplit = 2,
}

/**
 * Release Notes Data
 * 
 * Version Format: vMAJOR.MINOR.PATCH
 * 
 * Semantic Versioning Rules:
 * - MAJOR (x.0.0): Breaking changes → increments MAJOR, resets MINOR and PATCH to 0
 *   Example: 1.9.17 → 2.0.0
 * 
 * - MINOR (x.y.0): New features → increments MINOR, resets PATCH to 0
 *   Example: 1.9.17 → 1.10.0 (NOT 1.9.18)
 *   When you add a MINOR release, the PATCH number resets to 0
 * 
 * - PATCH (x.y.z): Bug fixes → increments PATCH only
 *   Example: 1.9.17 → 1.9.18
 *   PATCH only changes the last number
 * 
 * Type Mapping:
 * - feature → MINOR (new functionality, backward compatible)
 * - improvement → MINOR (enhancements to existing features)
 * - fix → PATCH (bug fixes)
 * - security → PATCH (security patches and vulnerability fixes)
 * 
 * Breaking changes → MAJOR (requires versionType: 'MAJOR')
 */
export const releaseNotesDataSE: IReleaseNote[] = [

    {
        version: 'v1.21.2',
        date: '2025-2-26',
        type: 'fix',
        versionType: 'PATCH',
        notes: [
            'Fixed Early Settlement Request UI: hide "Request a settlement" button when an existing request is present.',
            'Enhanced button styling and spacing consistency across Early Settlement actions',
            'Improved modal UX: disabled all buttons during delete operation to prevent multiple submissions.'
        ]
    },

    {
        version: 'v1.21.1',
        date: '2026-2-18',
        type: 'fix',
        versionType: 'PATCH',
        notes: [
            'Rename the invoice claim to Taxable claim and add the breakdown details to it: principal, fees, VAT and early settlement amounts'
        ]
    },

    {
        version: 'v1.21.0',
        date: '2026-2-8',
        type: 'feature',
        versionType: 'MINOR',
        notes: [
            'Introduced two Free Period modes: Discount Mode (percentage-based discounts) and Free Months Mode (free installments).',
            'You can now create Free Period offers with configurable start and end dates, service groups, and user limits.',
            'Added ability to view all Free Period requests for a company with detailed information including offer type, discount percentage, and free months.',
            'Implemented Free Period offer suspension functionality to deactivate offers when needed.',
            'Enhanced Free Period offers with support for maximum amount per user and maximum number of requests per user limits.',
            'Added Free Months Mode with configurable number of free months and minimum installments validation.',
            'Improved Free Period offer creation with automatic company maximum installments detection and validation.',
        ]
    },

    {
        version: 'v1.20.0',
        date: '2026-1-22',
        type: 'feature',
        versionType: 'MINOR',
        notes: [
            'Added balance cap to company info, create company, And edit company ',
            'Now active and resigned users in one invoice',
            'You can now collect and cancel advance requests from the Advance Requests view.',
            'You can now view release notes for the Ops Tool.',
            'Automated invoices',
            'Updated invoce PDF',
            'Prevent company deployment without essentials',
        ]
    },

    {
        version: 'v1.20.0',
        date: '2026-1-22',
        type: 'security',
        versionType: 'PATCH',
        notes: [
            'Enhanced token refresh mechanism with automatic cookie-based authentication for improved security.',
            'Implemented HttpOnly cookie support for refresh tokens to prevent XSS attacks and enhance security.',
            'Improved authentication flow: backend automatically reads refresh tokens from HttpOnly cookies, eliminating manual token handling.',
            'Enhanced security by removing client-side token storage and using secure HttpOnly cookies.',
            'Improved error handling for expired refresh tokens with automatic logout and user redirection.',
            'Added automatic token refresh on 401 Unauthorized responses with request queuing to prevent duplicate refresh calls.',
            'Enhanced request interceptor to handle token expiration gracefully with automatic retry mechanism.',
            'Added request queuing system to prevent multiple simultaneous token refresh attempts.',
        ]
    },
    {
        version: 'v1.20.0',
        date: '2026-1-22',
        type: 'fix',
        versionType: 'PATCH',
        notes: [
            'Improved overall visual consistency across modals and action buttons.',
            'Enhanced user experience with better visual feedback and interaction states.'
        ]
    },

];

export const releaseNotesDataEG: IReleaseNote[] = [
    {
        version: 'v1.19.35',
        date: '2024-01-30',
        type: 'feature',
        versionType: 'MINOR',
        notes: [
            'You can now set the commodity price through the Ops tool.',
            "As an HR, you can now view your company's transacting users.",
            'Minor Fixes to Blocking Issues & Request Early Settlement.',
            'VAPT Fixes: Refresh Token.'
        ]
    },
    {
        version: 'v1.19.34',
        date: '2024-01-22',
        type: 'security',
        versionType: 'PATCH',
        notes: [
            'You can now view release notes for the Ops Tool.',
            'Minor Fixes to Blocking Issues & Request Early Settlement.',
        ]
    },
    {
        version: 'v1.19.33',
        date: '2024-01-15',
        type: 'fix',
        versionType: 'PATCH',
        notes: [
            'You can now view release notes for the Ops Tool.',
            'Minor Fixes to Blocking Issues & Request Early Settlement.',
            'VAPT Fixes: Refresh Token.'
        ]
    },
];